module.exports = __webpack_public_path__ + "img/read-img4.b72776a2.png";